import { render, staticRenderFns } from "./IframeTopbar.vue?vue&type=template&id=6167e102&"
import script from "./IframeTopbar.vue?vue&type=script&lang=js&"
export * from "./IframeTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports